import { render } from "./TosMenu.vue?vue&type=template&id=6ad5f8a3&scoped=true"
import script from "./TosMenu.vue?vue&type=script&lang=js"
export * from "./TosMenu.vue?vue&type=script&lang=js"

import "./TosMenu.vue?vue&type=style&index=0&id=6ad5f8a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad5f8a3"]])

export default __exports__